import React, { Component } from "react";
import axios from "axios";
import "../style/PdfStats.css";
import DashboardEditor from "./DashboardEditor";
import keys from "../config";
import Fuse from "fuse.js";
export class PdfStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfs: null,
      pdfsCount: null,
      pdfForEditor: null,
      editorOpen: false,
      searchTerm: "",
    };
    this.renderPdfStats = this.renderPdfStats.bind(this);
    this.editor = this.editor.bind(this);
    this.closeEditor = this.closeEditor.bind(this);
  }
  async componentDidMount() {
    try {
      const url = keys.dashboardStatusUrl;
      const data = {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      };
      const pdfQueryResults = await axios.get(url, data);
      console.log(pdfQueryResults);
      const { Count: pdfsCount, Items: pdfs } = pdfQueryResults.data;
      console.log(pdfsCount, pdfs);
      this.setState({
        pdfsCount,
        pdfs,
      });
    } catch (error) {
      console.error(error);
    }
  }
  editor(pdf) {
    // this function gets an pdf and sends it to the metadata editor
    this.setState({ editorOpen: true, pdfForEditor: pdf });
  }
  closeEditor() {
    this.setState({ editorOpen: null });

    const isFirefox = typeof InstallTrigger !== "undefined";
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!isFirefox && !isSafari) {
      const body = document.querySelectorAll("body")[0];
      body.classList.remove("freeze");
    }
  }
  renderPdfStats() {
    const { pdfs } = this.state;
    const options = {
      shouldSort: true,
      threshold: 0.6,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        { name: "pieceName", weight: 0.7 },
        { name: "fileName", weight: 0.15 },
        { name: "composer", weight: 0.15 },
      ],
    };
    const fuse = new Fuse(pdfs, options);
    const filteredPdfs = fuse.search(this.state.searchTerm);
    let pdfsToShow;
    console.log("pdfsToShow", pdfsToShow);
    if (filteredPdfs.length === 0) {
      pdfsToShow = this.state.pdfs;
    } else {
      pdfsToShow = filteredPdfs;
    }
    return pdfsToShow.map((pdf) => (
      <div key={pdf.filename} className="stat-item">
        <li onClick={(e) => this.editor(pdf)}>
          <div>
            <span className="stat-name">Title</span>: {pdf.pieceName}
          </div>

          <div>
            <span className="stat-name">Composer:</span>
            &nbsp;{pdf.composer}
          </div>
          <div className="stat-item-categories">
            <span className="stat-name">Tags:</span>{" "}
            {pdf.category.split(",").join(", ")}
          </div>
          <div>
            <span className="stat-name">Filename for authenticated users:</span>{" "}
            {pdf.filename}
          </div>
          <div>
            <span className="stat-name">
              Filename for unauthenticated users:
            </span>{" "}
            {pdf.unAuthFilename}
          </div>
        </li>
      </div>
    ));
  }
  render() {
    const { pdfsCount, pdfs } = this.state;
    console.log("pdfs", pdfs);
    return (
      <div>
        {!pdfs && <h1>LOADING!!!!</h1>}
        <h3>PDF stats</h3>
        <p>
          You currently have&nbsp;
          {pdfs && pdfs.length}
          &nbsp;motets uploaded
        </p>
        <div className="dashboard-instructions">
          <h2 className="tip">Search, edit, delete:</h2>
          <p className="tip">
            You can search through all the PDFs you've uploaded, add/remove/edit
            tags, replace files, and delete. Click on a listing and the editor
            will pop up!
          </p>
        </div>
        <div className="dashboard-search">
          <input
            value={this.state.searchTerm}
            onChange={(e) => this.setState({ searchTerm: e.target.value })}
            type="text"
            placeholder="Search motets"
            className="sign-input"
          />
        </div>

        {pdfsCount && pdfsCount > 0 && (
          <div className="stat-window">
            {this.state.pdfForEditor && this.state.editorOpen && (
              <DashboardEditor
                closeEditor={this.closeEditor}
                pdf={this.state.pdfForEditor}
              />
            )}

            <ul>{pdfsCount && pdfsCount > 0 && this.renderPdfStats()}</ul>
          </div>
        )}
      </div>
    );
  }
}

export default PdfStats;



// WEBPACK FOOTER //
// ./src/components/PdfStats.js